export default __webpack_public_path__ + "static/media/pinhao.5ed61e7b.png";